function blockCard(container) {    
    
    const mainLinkClass = container.classList[0];
    const mainLink = container.querySelector(`.${mainLinkClass}__link`);
    const clickableElements = Array.from(container.querySelectorAll("a"));
    //we are using 'a' here for simplicity but ideally you should put a class like 'clickable' on every clicable element inside card(a, button) and use that in query selector
    console.log(clickableElements)
    clickableElements.forEach((ele) =>
        ele.addEventListener("click", (e) => e.stopPropagation())
    );
    function handleClick(event) {
        const noTextSelected = !window.getSelection().toString();
        if (noTextSelected) {
            mainLink.click();
        }
    }
    container.addEventListener("click", handleClick);
}

document.querySelectorAll('.wdb-hero-card, .wdb-highlight-card, .wdb-m-card').forEach(component => {
    if(!component) {
        return;
    }
    blockCard(component);
});
